import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import swal from 'sweetalert2';
import { Plan } from '../../../core/models/personalInfo';
import { AccountService } from '../../../core/services/account.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { User } from 'src/app/core/models/user';
import { SignalRService } from 'src/app/core/services/signalr.service';
import moment from 'moment';
import { PartnerLenderConfig, PlanRuleMapper } from 'src/app/core/utils/emi-calculation-utils';

@Component({
    selector: 'app-assist-payment-plan',
    templateUrl: './assist-payment-plan.component.html',
    styleUrls: ['./assist-payment-plan.component.scss'],
})
export class AssistPaymentPlanComponent implements OnInit {
    public href: string = '';

    public travelPlan: string = '';

    public FirstName: string = '';

    public Mobile: string = '';

    public Email: string = '';

    public PAN: string = '';

    public DOB: string = '';

    public Address: string = '';

    public DocsRequired: string = '';

    public Downpayment: string = '';

    public EmiAmount: string = '';

    public Loanamount: string = '';

    public FirstEMIDueDate: string = '';

    public NumberOfTotalEMI: string = '';

    public travelPlanId: string = '';

    constructor(
        private route: ActivatedRoute,
        private accountService: AccountService,
        private spinner: NgxSpinnerService,
        private router: Router,
        private sessionTimerService: SessionTimerService,
        private signalRService: SignalRService
    ) { }

    public plans!: Plan[];

    public newPlans: Plan[] = [];

    public inPrincipleAmount!: number;

    public response1!: any;

    public isPlanSelected: boolean = false;

    public hasLimitExhausted: boolean = false;

    public selectedPlan: Plan;

    public conditionAccept: boolean = false;
    public config: PartnerLenderConfig;

    public async ngOnInit() {
        this.spinner.hide();

        const lender = this.route.snapshot.paramMap.get('id')!;

        await this.getEMIPlanConfiguration();
        this.inPrincipleAmount = +MemoryStorageService.getItem('availableLimit') || +MemoryStorageService.getItem('approvalAmount');

        this.Loanamount = MemoryStorageService.getItem('loanAmount') !== null ? MemoryStorageService.getItem('loanAmount') : MemoryStorageService.getItem('TravelCost');
        let response: Plan[] = null;
        try {
            this.spinner.show();
            if (lender) {
                response = await firstValueFrom(this.accountService.GetProposedLenderPlans(lender));
            }
            else {
                response = await firstValueFrom(this.accountService.GetProposedPlans());
            }
            this.plans = response;
            const creditScore = MemoryStorageService.getItem('creditscore');
            this.newPlans = PlanRuleMapper.getSimplifiedTravelPlans(
                Number(this.Loanamount),
                Number(creditScore),
                this.config.availableTenure || '',
                this.config.processingFee || '',
                this.config.processingFeeType || '',
                this.config.noCostTenure || '',
                this.config.noCostProcessingFee || '',
                this.config.noCostProcessingFeeType || '',
                this.config.roi || '',
                this.config.interestType || ''
            );
            // Adding isCollapsed to handle collapse effect in mobile device.
            this.plans.forEach(plan => plan.isCollapsed = true);
            this.spinner.hide();
        } catch (err) {
            console.log(err);
        }
        //not checking now
        //this.hasLimitExhausted = MemoryStorageService.getItem("hasLimitExhausted") === 'true';
        if (this.hasLimitExhausted) {
            this.sessionTimerService.SetShowTimer(false);
            this.sessionTimerService.stopTimer();

            //Not showing Exhause message and redirecting to manual Underwritting 
            this.hasLimitExhausted = false;
            this.router.navigateByUrl('/assist-journey/assist-underwrite');
            return
        }

        this.accountService.userMobile$.subscribe(value => this.Mobile = value);
        // this.sessionTimerService.SetShowTimer(true);
        // this.sessionTimerService.resumeTimer();
        this.checkPlanEligibility(this.plans);
    } private async getEMIPlanConfiguration() {
        try {
            const configurationResponse = await lastValueFrom(this.accountService.GetEMIPlanConfiguration("0"))
            if (configurationResponse['data'] !== null) {
                this.config = PlanRuleMapper.mapToPartnerLenderConfig(configurationResponse['data']);
            }

        } catch (error) {
            console.log(error);
        }
    }

    public SelectPlan(plan: Plan) {
        this.selectedPlan = plan;
        this.isPlanSelected = true;
    }

    public handleUpdateSelectedPlan(plan: Plan) {
        console.log("working")
        this.selectedPlan = plan;
        this.ProceedToNach();
    }

    public async ProceedToNach() {
        //save to db
        //save to MemoryStorageService
        this.spinner.show();
        MemoryStorageService.setItem('finalplan', JSON.stringify(this.selectedPlan));
        const finalPlan = JSON.parse(MemoryStorageService.getItem('finalplan'));
        this.travelPlanId = new URL(finalPlan.navigate_url).search.replace('?travelplan=', '');
        await this.accountService.GetTravelPlan(this.travelPlanId).subscribe(
            (resp) => {
                this.spinner.hide();
                this.response1 = resp;
                const response = resp['data'];
                if (response != null) {
                    if (response.status == "EXPIRED") {
                        swal.fire('The Plan is expired. Please try again');
                        this.router.navigateByUrl("/sorry");

                    } else if (response.status == "INVALID") {
                        swal.fire('The selected plan is not valid anymore!');
                        this.router.navigateByUrl("/sorry");
                    }
                    else {


                        var user: User = {
                            userName: response.email,
                            email: response.email,
                            mobileNumber: response.mobileNumber,
                            token: response.token,
                            docs: [
                                {
                                    bankstatement: false,
                                },
                            ],
                            emiamount: Number(response.plan.emi_amount!),
                            collectionAmount: Number(response.plan.loan_amount!),
                            fullname: response.firstname + ' ' + response.lastName,
                            firstCollectionDate: moment(response.plan.emi_date).format('DD-MMM-YYYY'),
                            showFooter: true,
                        };

                        MemoryStorageService.setItem("loanAmount", response.plan.loan_amount!);
                        MemoryStorageService.setItem('userSource', response.userSource);
                        MemoryStorageService.setItem("partnerTransactionId", response.partnerTransactionId);
                        MemoryStorageService.setItem('user', JSON.stringify(user));
                        MemoryStorageService.setItem('finalplan', JSON.stringify(response.plan));
                        localStorage.setItem('partnercallback', response.partnerCallbackUrl);

                        this.accountService.setCurrentUser(user);
                        this.signalRService.initSignalR(user.token);

                        this.router.navigateByUrl('/assist-journey/loan-agreement');
                    }
                }
                else {
                    this.router.navigateByUrl('/assist-journey/session-expired');
                }
            },
            (error) => {
                this.spinner.hide();
                if (error.errors != null || error.errors != undefined) {
                    swal.fire(error.errors);
                }
            }
        );
    }

    public GenerateTitle(value: string) {
        if (value == 'PBYF' || value == 'FNPL') {
            return 'from';
        } else if (value == 'FNP') {
            return 'pay every 15 days';
        } else if (value == 'BP') {
            return 'pay once';
        } else {
            return value;
        }
    }

    public GeneratePayIn(value: string) {
        if (value == 'PBYF') {
            return 'Pay before your travel';
        } else if (value == 'FNPL') {
            return 'pay even after your travel';
        } else if (value == 'FNP') {
            return 'Pay in 2 to 6 instalments';
        } else if (value == 'BP') {
            return 'Pay in one instalment';
        } else {
            return value;
        }
    }

    public GeneratePayUpto(value: string, tenure: string) {
        if (value == 'PBYF' || value == 'FNPL') {
            return 'Spread the cost over ' + tenure + ' months';
        } else if (value == 'FNP') {
            return 'Spread the cost over 3 months';
        } else if (value == 'BP') {
            return 'Pay upto 45 days from booking';
        } else {
            return value;
        }
    }

    public GenerateProcessingFee(plan: Plan) {
        return Math.round(plan.processing_fee! + plan.gst!).toLocaleString('en-IN');
    }

    public GeneratePayNow(plan: Plan) {
        return Math.round(plan.processing_fee! + plan.gst! + plan.downpayment!).toLocaleString('en-IN');
    }

    public GenerateInterest(plan: Plan) {
        return Math.round((plan.emi_amount! * plan.tenor!) - (plan.loan_amount!)).toLocaleString('en-IN');
    }

    public GenerateTotalPayable(plan: Plan) {
        return Math.round(plan.emi_amount! * plan.tenor!).toLocaleString('en-IN');
    }

    public checkPlanEligibility(plans: any[]) {
        const hasEligiblePlan = plans.some(plan => plan.plan_eligibility);

        if (!hasEligiblePlan) {
            return this.router.navigateByUrl('/assist-journey/assist-underwrite');
        }
    }

    public FormatValRound(val) {
        return Math.round(val)?.toLocaleString('en-IN');
    }

    public testDataMapper(jsonData) {
        const plans: Plan[] = JSON.parse(jsonData).map((item: any) => ({
            plan_id: item.plan_id,
            plan_name: item.plan_name,
            plan_eligibility: item.plan_eligibility,
            package_cost: item.package_cost,
            loan_amount: item.loan_amount,
            downpayment: item.downpayment,
            processing_fee: item.processing_fee,
            upfrontAmountPayDate: item.upfrontAmountPayDate,
            emi_amount: item.emi_amount,
            emi_date: new Date(item.emi_date),
            tenor: item.tenor,
            roi: item.roi,
            gst: item.gst,
            nach_frequency: item.nach_frequency,
            status: item.status,
            message: item.message,
            emiPlan: item.emiPlan,
            navigate_url: item.navigate_url,
            qr_code: item.qr_code,
        }));
        return plans;
    }
}
